export const VUE_APP_MODE = process.env.VUE_APP_MODE;

const PROTOCOL = window.location.protocol;
const host = window.location.host.replace("www", "").replace("app", "");

// 环境变量相关配置
export const MODE_CONF = {
  development: {
    base_url: "http://gateway.eline56.test",
    base_url_agent: 'http://192.cgofish.test',
    base_code: "http://gateway.eline56.test"
  },
  dev: {
    base_url: "//gateway.dev.eline56-inc.com",
    base_url_agent: window.location.origin,
  },
  test: {
    base_url: "//gateway.test.eline56-inc.com",
    base_url_agent: window.location.origin,
  },
  prepub: {
    base_url: "//gateway.prepub.eline56.com",
    base_url_agent: window.location.origin,
  },
  production: {
    base_url: '//gateway.eline56.com',
    // base_url: "/gateway",
    base_url_agent: window.location.origin,
    base_code: "https://gateway.eline56.com"
  },
  gray: {
    base_url: "//gateway-gray.eline56.com",
    base_url_agent: window.location.origin,
  },
}[VUE_APP_MODE];
